import { cn } from "@/lib/utils";

/**
 * Architectural vertical hairlines that align with the 12-column layout grid.
 * Purely decorative.
 */
export const GridLines = ({ dark = false, className = "", fade = false }) => {
  const line = dark ? "hl-light" : "hl";
  return (
    <div
      aria-hidden="true"
      className={cn("pointer-events-none absolute inset-0 container-x", className)}
      style={fade ? { maskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)", WebkitMaskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)" } : undefined}
    >
      <div className="grid h-full grid-cols-4 lg:hidden">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className={cn("border-l", line, i === 3 && "border-r")} />
        ))}
      </div>
      <div className="hidden h-full grid-cols-12 lg:grid">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className={cn("border-l", line, i === 11 && "border-r")} />
        ))}
      </div>
    </div>
  );
};
